import React from "react";
import { Table } from "react-bootstrap";
import { FooterBtnState, LanguageSetting } from "../../common/Const";
import styled from "styled-components";
import ktvGeoJsonData from "../../geoJson/ktv.json";

type KTVTableProps = {
  handleFilterShow: () => void;
  langSetting: LanguageSetting;
  serchedShopName: string;
  setCenterOfMap: (position: L.LatLngTuple) => void;
  setIsMoveCenter: (isMoveCenter: boolean) => void;
  setPinId: (id: string) => void;
  setZoomOfMap: (magnification: number) => void;
};

const KTVTable: React.FC<KTVTableProps> = ({
  handleFilterShow,
  langSetting,
  serchedShopName,
  setCenterOfMap,
  setIsMoveCenter,
  setPinId,
  setZoomOfMap,
}) => {
  return (
    <StyledTable striped borderless hover variant="dark" size="sm">
      <thead>
        <tr>
          <th rowSpan={2}>{langSetting === "JA" ? "店名" : "Shop name"}</th>
          <th colSpan={4}>{langSetting === "JA" ? " 料金 (PHP)" : "Price"}</th>
        </tr>
        <tr>
          <th> {langSetting === "JA" ? "90min" : "90min"}</th>
          <th> {langSetting === "JA" ? "60min" : "60min"}</th>
          <th> {langSetting === "JA" ? "LD" : "LD"}</th>
          <th> {langSetting === "JA" ? "指名" : "Request"}</th>
        </tr>
      </thead>
      <tbody>
        {ktvGeoJsonData.features
          .filter(
            (a: any) =>
              a.properties.shopName
                .toLowerCase()
                .indexOf(serchedShopName.toLowerCase()) > -1
          )
          .sort((a: any, b: any) => {
            if (a["properties"]["setPrice90"] < b["properties"]["setPrice90"])
              return 1;
            if (a["properties"]["setPrice90"] > b["properties"]["setPrice90"])
              return -1;
            return 0;
          })
          .map((row) => {
            return (
              <tr
                key={`tr${row.properties.id}`}
                onClick={() => {
                  if (document.querySelectorAll(".leaflet-marker-icon"))
                    document
                      .querySelectorAll(".leaflet-marker-icon")
                      .forEach((e) => e.classList.remove("serched-pin"));
                  setCenterOfMap(
                    row.geometry.coordinates
                      ? [
                          Number(row.geometry.coordinates[1]),
                          Number(row.geometry.coordinates[0]),
                        ]
                      : [14.571649689172614, 120.98437441430472]
                  );
                  setZoomOfMap(19);
                  setIsMoveCenter(true);
                  setPinId(`.KTV${row.properties.id}`);

                  let e = new Event("click", {
                    bubbles: true,
                    cancelable: true,
                  });
                  let pin = document.querySelector(
                    `img.leaflet-marker-icon.KTV${row.properties.id}`
                  ) as HTMLElement;
                  if (pin) {
                    pin.classList.add("serched-pin");
                    pin.dispatchEvent(e);
                  }
                  handleFilterShow();
                }}
              >
                <td key={`shopname${row.properties.id}`}>
                  {" "}
                  {row.properties.shopName.split("|||")[0]}
                  <span className="tag-for-search">
                    {row.properties.shopName.split("|||")[1]}
                  </span>
                </td>
                <td key={`90price${row.properties.id}`}>
                  {row.properties.setPrice90 ? row.properties.setPrice90 : "-"}
                </td>
                <td key={`60price${row.properties.id}`}>
                  {row.properties.setPrice60 ? row.properties.setPrice60 : "-"}
                </td>
                <td key={`ld${row.properties.id}`}>
                  {row.properties.ladiesDrink
                    ? row.properties.ladiesDrink
                    : "-"}
                </td>
                <td key={`lq${row.properties.id}`}>
                  {row.properties.ladiesRequest
                    ? row.properties.ladiesRequest
                    : "-"}
                </td>
              </tr>
            );
          })}
      </tbody>
    </StyledTable>
  );
};
const StyledTable = styled(Table)`
  thead {
    position: sticky;
    top: 0;
    left: 0;
  }
  tbody {
    overflow-x: hidden;
  }
  th {
    font-size: 0.55rem;
    font-weight: 800;
    width: 100px;
  }
  td {
    font-size: 0.6rem;
    width: 100px;
  }
`;

export default KTVTable;
